import { View } from 'es6/components/view'
import { InViewPortMixin } from 'es6/mixins/in-viewport-mixin'
import $ from 'init/jquery'
import Backbone from 'init/backbone'
import { Defaults } from 'es-decorators'
import extend from 'lodash/extend'
import merge from 'lodash/merge'
import { okoPush } from 'helpers/oko-helpers'

/**
 * Класс для отдельного баннера
 */

@Defaults({
  // флаг видимости баннера, по-умолчанию считаем что баннер виден
  visibilityFlag: true,
  // данные баннера
  bannerData: '',
  additionalOptions: ['mainWindow', 'eventBus'],
  sent: [],
  events: {
    'click .js-chponck-link': 'sendToOkoClick',
  },
})
export class ChponkView extends View {
  /**
   * @inheritDoc
   */
  beforeRun () {
    // если баннер не имеет всех необходимых атрибутов то отписываемся от событий и кидаем ошибку в Raven
    if (!this.validateDataAttributes()) {
      this.stopViewportListening()

      if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
        let errorMessage = `Ошибка data-атрибутов баннера: ${this.getBannerDataAttributesError().join(';')}`

        Raven.captureException(new Error(errorMessage))
      }

      return
    }
    this._setBannerData()
    this._setCarouserListener()
    this._setPopupChponkListener()
  }

  /**
   * Установка данных текущего баннера
   *
   * @private
   */
  _setBannerData () {
    this.bannerData = this._createKey(this.$el)
  }

  /**
   * Установка слушателя открытия попапа категорий для отправки статистики
   *
   * @private
   */
  _setPopupChponkListener () {
    const $parent = this.$el.parent(),
      isChponk = $parent.hasClass('chponk-menu-gfx')
    if (isChponk) {
      this.visibilityFlag = false
      this.listenTo(Backbone, 'catalog-showSubmenu-item', this.checkPopupChponkVisible)
    }
  }

  /**
   * Установка слушателя смены баннера в карусели для отправки статистики
   *
   * @private
   */
  _setCarouserListener () {
    const parent = this.$el.parent(),
      isOwlChponk = parent.hasClass('owl-item'),
      isCssChponk = parent.hasClass('carousel-item')
    if (isOwlChponk || isCssChponk) {
      this.visibilityFlag = (isOwlChponk && parent.hasClass('active'))
        || (isCssChponk && parent.css('opacity') === 1)
      this.listenTo(this.eventBus, 'carousel.changed.item', this.changeCarouselBanner)
    }
  }

  /**
   * Формирует ключ баннера
   *
   * @param {jQuery} $elements Элементы по данным которых формируется ключ
   * @returns {string} Уникальный ключ баннера
   * @private
   */
  _createKey ($elements) {
    return JSON.stringify(this.getBannerDataAttributes($elements))
  }

  /**
   * Поменялся баннер в карусели, проверяем не мы ли это
   *
   * @param {HTMLElement|HTMLElement[]} slide Слайд или несколько слайдов карусели.
   */
  changeCarouselBanner (slide) {
    if (Array.isArray(slide)) {
      slide.forEach(this.checkPopupChponkVisible.bind(this))
    } else {
      this.checkPopupChponkVisible(slide)
    }
  }

  /**
   * Отсылаем видимый баннер из открытого попапа в око
   * @param {HTMLElement} item Баннер из открытого попапа
   */
  checkPopupChponkVisible (item) {
    const $banner = $(item).children().eq(0)
    if (this._createKey($banner) === this.bannerData) {
      this.visibilityFlag = true
      this.showListening(this.mainWindow.getScrollTop())
      if (this.viewPortModel.get('in')) {
        this.sendToOko()
      }
    }
  }

  /**
   * Отправляем видимый баннер в ОКО
   */
  sendToOko () {
    if (this.sent.indexOf(this.bannerData) === -1 && this.isValid) {
      // Отписываемся от событий перед отправкой в око
      this.stopAllListening()
      okoPush(merge({
        n: 'banner',
      }, this.getBannerDataAttributes(this.$el)))
      this.sent.push(this.bannerData)
    }
  }

  /**
   * Отправляем событие в око пти клике на баннер
   */
  sendToOkoClick () {
    okoPush(merge({
      n: 'banner-click',
    }, this.getBannerDataAttributes(this.$el)))
  }

  /**
   * Отписываемся от всех событий
   */
  stopAllListening () {
    this.stopViewportListening()
    this.stopListening(this.eventBus, 'carousel.changed.item')
  }

  /**
   * Получение идентификатора баннера для вьюпорта
   * @returns {string} строка с json данными баннера или id-ми банеров слайда
   */
  getViewPortIdentifier () {
    return this.bannerData
  }

  /**
   * Баннер попал во viewport
   */
  inViewPort () {
    // если элемент не виден то ничего не отправляем
    if (!this.isVisible()) {
      return
    }
    this.sendToOko()
  }

  /**
   * Баннер вышел из viewport
   */
  outViewPort () {
    // нам не нужно реагировать на это событие
  }

  /**
   * Проверят что все data-атрибуты баннера на месте
   *
   * @returns {boolean}
   */
  validateDataAttributes () {
    this.isValid = !this.getBannerDataAttributesError().length
    return this.isValid
  }

  /**
   * Возвращает массив с ошибками в data-атрибутах баннера
   *
   * @returns {Array} errors
   */
  getBannerDataAttributesError () {
    let data = this.getBannerDataAttributes(this.$el)

    let errors = []

    if (isNaN(data['id'])) {
      errors.push('Не указан ID баннера')
    }
    if (isNaN(data['num'])) {
      errors.push('Не указан номер баннера')
    }
    if (!data['url'].length) {
      errors.push('Не указан URL баннера')
    }
    if (isNaN(data['place_id'])) {
      errors.push('Не указана позиция баннера')
    }

    return errors
  }

  /**
   * Возвращает data-атрибуты баннера
   *
   * @param {$} $banner jquery-объект баннера
   * @returns {Object}
   */
  getBannerDataAttributes ($banner) {
    return {
      'id': parseInt($banner.data('chponckId'), 10),
      'num': parseInt($banner.data('chponckNum'), 10),
      'url': $banner.data('chponckUrl') ? String($banner.data('chponckUrl')).trim() : '',
      'place_id': parseInt($banner.data('chponckPlaceId'), 10),
    }
  }

  /**
   * Определяет видимость элемента
   *
   * @returns {boolean}
   */
  isVisible () {
    return this.visibilityFlag
  }
}

// подключаем слежение за попаданием во viewport при скролле (для ОКО)
extend(ChponkView.prototype, InViewPortMixin)
